import { useEffect } from "react";
import { useAppDispatch } from "../useAppDispatch";
import { useAppSelector } from "../useAppSelector";
import { RequestState } from "../../constants/request-state";
import { isRequestNone } from "../../utils";
import { securityBwicHistoryActions } from "../../actions/entities/security-bwic-history.actions";

export function useSecurityBwicHistory(securityId: number) {
    const dispatch = useAppDispatch();
    const { requestState, bwics } = useAppSelector(s => s.entities.securityBwicHistory.history[securityId])
        ?? { requestState: RequestState.none, bwics: { count: 0, securities: [] } };

    useEffect(() => {
        if (securityId && isRequestNone(requestState)) {
            dispatch(securityBwicHistoryActions.request(securityId));
        }
    }, [requestState, securityId, dispatch]);

    return { requestState, bwics };
}

export function useSecurityBwicHistoryAutoReset() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(securityBwicHistoryActions.reset());
    }, [dispatch])
}